class BundleVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Wait for window load to ensure all elements are in the DOM
    if (document.readyState === "complete") {
      this.initialize();
    } else {
      window.addEventListener("load", () => this.initialize());
    }
  }

  initialize() {
    this.form = document.getElementById(this.getAttribute("form"));
    this.buyButtons = document.querySelector(
      `buy-buttons[form="${this.getAttribute("form")}"]`
    );
    this.submitButton = this.buyButtons?.querySelector('button[type="submit"]');
    this.CustomBuyButton = this.form
      ?.closest(".product-info__buy-buttons")
      ?.querySelector(".multiple_items_ATC_button");
    this.CustomSubmitButton = this.form
      ?.closest(".product-info__buy-buttons")
      ?.querySelector(".multiple_items_ATC_button")
      ?.querySelector('button[type="submit"]');
    console.log("Initialized with form:", this.form?.id);
    console.log("Found buy buttons:", this.buyButtons);
    console.log("Found submit button:", this.submitButton);

    // Add form submit listener
    if (this.form) {
      this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    }
    if (this.CustomSubmitButton) {
      this.CustomBuyButton.addEventListener("click", (e) =>
        this.handleSubmit(e)
      );
    }

    this.init();
  }

  init() {
    this.setupEventListeners();
    // Initially hide all .element-two
    this.querySelectorAll(".element-two").forEach((el) => (el.hidden = true));
    // Show .element-two for default selected option
    const defaultSelected = this.querySelector('input[type="radio"]:checked');
    if (defaultSelected) {
      this.handleOptionChange(defaultSelected);
    }
  }

  setupEventListeners() {
    // Radio button change events
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener("change", () => {
        console.log("Bundle option changed:", radio.value);
        this.handleOptionChange(radio);
      });
    });

    // Quantity button clicks
    this.querySelectorAll(".quantity-selector__button[data-action]").forEach(
      (button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          const action = button.dataset.action;
          const variantId = button.dataset.variantId;
          const bundleQuantity = parseInt(button.dataset.bundleQuantity);

          console.log("Quantity button clicked:", {
            action,
            variantId,
            bundleQuantity,
          });

          this.handleQuantityButton(action, variantId, bundleQuantity);
        });
      }
    );
  }

  handleQuantityButton(action, variantId, bundleQuantity) {
    const input = this.querySelector(
      `.quantity-selector[data-bundle-quantity="${bundleQuantity}"] input[data-variant-id="${variantId}"]`
    );
    if (!input) {
      console.error(
        "Could not find input for variant:",
        variantId,
        "and bundle quantity:",
        bundleQuantity
      );
      return;
    }

    console.log("Found input:", input);
    console.log("Current input value:", input.value);
    let currentValue = parseInt(input.value) || 0;
    let newValue = currentValue;

    if (action === "plus") {
      // Check if increasing would exceed bundle total
      const currentTotal = this.getCurrentBundleTotal(
        bundleQuantity,
        variantId
      );
      if (currentTotal < bundleQuantity) {
        newValue = currentValue + 1;
        console.log("Increasing to:", newValue);
      } else {
        console.log(
          "Cannot increase: would exceed bundle total of",
          bundleQuantity
        );
        return;
      }
    } else if (action === "minus") {
      newValue = Math.max(currentValue - 1, 0);
      console.log("Decreasing to:", newValue);
    }

    console.log("Setting input value to:", newValue);
    input.value = newValue;

    // Force input change event
    input.dispatchEvent(new Event("change", { bubbles: true }));

    this.updateSubmitButtonState();
  }

  getCurrentBundleTotal(bundleQuantity, excludeVariantId = null) {
    const inputs = this.querySelectorAll(
      `.quantity-selector[data-bundle-quantity="${bundleQuantity}"] .quantity-selector__input`
    );
    const total = Array.from(inputs).reduce((sum, input) => {
      // Skip the current variant when checking if we can increase
      if (excludeVariantId && input.dataset.variantId === excludeVariantId) {
        return sum + (parseInt(input.value) || 0);
      }
      return sum + (parseInt(input.value) || 0);
    }, 0);

    console.log(
      "Current bundle total:",
      total,
      "Bundle quantity:",
      bundleQuantity
    );
    return total;
  }

  handleOptionChange(radio) {
    console.log("Handling option change for:", radio.value);

    // Hide all .element-two first
    this.querySelectorAll(".element-two").forEach((el) => (el.hidden = true));

    const selectedElementTwo =
      radio.nextElementSibling.querySelector(".element-two");
    if (selectedElementTwo) {
      selectedElementTwo.hidden = false;
      console.log("Showing element-two for:", radio.value);
    }

    // Reset quantities when changing options
    this.querySelectorAll(".quantity-selector__input").forEach((input) => {
      input.value = "0";
    });

    this.updateSubmitButtonState();
  }

  updateSubmitButtonState() {
    if (!this.submitButton) return;

    const selectedRadio = this.querySelector('input[type="radio"]:checked');
    if (!selectedRadio) return;

    if (selectedRadio.classList.contains("default_variant")) {
      console.log("Default variant selected, enabling submit button");
      this.submitButton.disabled = false;
      if (this.submitButton.hasAttribute("hidden"))
        this.submitButton.removeAttribute("hidden");
      if (this.CustomBuyButton) this.CustomBuyButton.setAttribute("hidden", "");
      return;
    } else {
      if (!this.submitButton.hasAttribute("hidden"))
        this.submitButton.setAttribute("hidden", "");
      if (this.CustomBuyButton) this.CustomBuyButton.removeAttribute("hidden");
    }

    const selectedElementTwo =
      selectedRadio.nextElementSibling.querySelector(".element-two");
    if (!selectedElementTwo) return;

    const maxBundleQuantity = parseInt(
      selectedElementTwo
        .querySelector("input[data-max-quantity]")
        .getAttribute("data-max-quantity")
    );
    const currentTotal = this.getCurrentBundleTotal(maxBundleQuantity);

    console.log(
      "Current total:",
      currentTotal,
      "Max bundle quantity:",
      maxBundleQuantity
    );
    this.CustomSubmitButton.disabled = currentTotal !== maxBundleQuantity;
  }

  async handleSubmit(event) {
    event.preventDefault(); // Always prevent default form submission
    const selectedRadio = this.querySelector('input[type="radio"]:checked');

    if (selectedRadio.classList.contains("default_variant")) {
      console.log("Submitting default variant");
      const formData = new FormData(this.form);
      const items = [
        {
          id: formData.get("id"),
          quantity: 1,
        },
      ];

      await this.submitToCart(items, true);
      return false;
    }

    const selectedElementTwo =
      selectedRadio.nextElementSibling.querySelector(".element-two");
    const items = Array.from(
      selectedElementTwo.querySelectorAll(".quantity-selector__input")
    )
      .filter((input) => parseInt(input.value) > 0)
      .map((input) => ({
        id: input.getAttribute("data-variant-id"),
        quantity: parseInt(input.value),
      }));

    console.log("Submitting bundle with items:", items);

    this.CustomSubmitButton.setAttribute("disabled", "disabled");
    this.CustomSubmitButton.setAttribute("aria-busy", "true");

    await this.submitToCart(items, false);
    return false;
  }

  async submitToCart(items, has_default_variant) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error("Failed to add to cart");

      if (has_default_variant == true) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } else {
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
        this.CustomSubmitButton.removeAttribute("disabled");
        this.CustomSubmitButton.removeAttribute("aria-busy");
      }
      console.log("Successfully added bundle to cart");
    } catch (error) {
      console.error("Error adding bundle to cart:", error);
    }
  }
}

customElements.define("variant-picker", BundleVariantPicker);
